import { Component } from '@angular/core';
import { FieldComponent } from 'tuain-ng-forms-lib';

@Component({
  selector: 'app-select',
  templateUrl: './app-select.component.html',
})
export class AppSelectComponent extends FieldComponent {

  override start() {
    super.start();
    this.options = this.options.sort(function (a, b) {
      if (a.fieldOptionValue > b.fieldOptionValue) { return 1; }
      if (a.fieldOptionValue < b.fieldOptionValue) { return -1; }
      return 0;
    });
  }

  filterInput(inputText, option) {
    const upperCaseInput = inputText.toUpperCase();
    const { nzLabel, nzValue, nzDisabled, nzHide } = option;
    return (!nzDisabled && !nzHide && (nzLabel?.toString()?.toUpperCase().includes(upperCaseInput)
      || nzValue?.toString()?.toUpperCase().includes(upperCaseInput)));
  }
}
